export default "__VITE_ASSET__BgX$87HI__"